import FormSection from '../../Common/form/formSection/FormSection'
import Civility from '../fields/Civility'
import FirstName from '../fields/FirstName'
import Idnps from '../fields/Idnps'
import LastName from '../fields/LastName'
import Rpps from '../fields/Rpps'
import Title from '../fields/Title'

const IdentitySection = () => (
    <FormSection label="Informations d'identité">
        <Civility />
        <Title />
        <LastName />
        <FirstName />
        <Rpps />
        <Idnps />
    </FormSection>
)

export default IdentitySection
